module.exports = __webpack_public_path__ + "static/media/PG-Character-Sun-Lolly.d273aa95.png";